import { Pipe, PipeTransform } from '@angular/core';

import { IFieldLabel } from './../../shared/interfaces/common.interface';

interface IncomingCustomField {
  incomingField :string;
  lumField :string;
}

@Pipe({
  name: 'channelOutgoingCustomFields',
  standalone: true,
})
export class ChannelOutgoingCustomFieldsPipe implements PipeTransform {
  transform(
    incomingCustomFields :IncomingCustomField[],
    outgoingCustomFields :IFieldLabel[],
  ) :IFieldLabel[] {
    const incomingFields = incomingCustomFields.map((field) => ({
      field: field.incomingField,
      label: field.incomingField,
    }));

    return [...incomingFields, ...outgoingCustomFields];
  }
}
